import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useWorkspaceSettings } from 'app/components/workspace-settings/useWorkspaceSettings'
import { WorkspaceSettingsComponent } from 'app/components/workspace-settings/WorkspaceSettingsComponent'
import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useFeatureToggle } from 'app/hooks/useFeatureToggle'
import { useIsOrgUser } from 'app/hooks/useIsOrgUser'
import { useUser } from 'app/utils'

// Workspace Settings
// observer: reads the staff-v2 feature toggle and authStore.user in render; both resolve
// asynchronously / change in place, so the guard needs an observer wrapper (TRK-6020).
const WorkspaceSettings = observer(function WorkspaceSettings() {
  const user = useUser()
  const staffV2Enabled = useFeatureToggle(`staff-v2`)
  const checkPermission = useCheckPermission()
  const isOrgUser = useIsOrgUser()

  if (!user) return <></>

  if (!user.workspaceId) return <Navigate to="/" replace />

  if (staffV2Enabled && !isOrgUser) {
    if (!checkPermission(`settings:workspace`)) {
      return <Navigate to={`/settings/users/${user.id}`} replace />
    }
  }

  // Mount the data hook only after auth/permission guards so we don't call hooks
  // conditionally in this component (react-hooks/rules-of-hooks).
  return <WorkspaceSettingsContent />
})

export default WorkspaceSettings

function WorkspaceSettingsContent() {
  const props = useWorkspaceSettings()
  return <WorkspaceSettingsComponent {...props} />
}
